const homepageServices = {
	en: [
		{
			icon: 'faShopify',
			heading: 'Shopify Services',
			intro: 'We specialize in creating robust and scalable Shopify stores tailored to your business needs. Our team of experienced developers ensures that your online store is not only visually appealing but also optimized for performance and user experience.',
			sublist: [
				'Custom Theme Development',
				'Responsive Design',
				'App Integration',
				'SEO Optimization',
				'Performance Optimization',
				'Ongoing Support and Maintenance',
			],
			url: '/services/shopify-development',
		},
		{
			icon: 'plusIcon',
			heading: 'Shopify Plus',
			intro: 'For high-growth enterprises seeking advanced e-commerce solutions, our Shopify Plus Development services offer unparalleled customization, scalability, and performance enhancements.',
			sublist: [
				'Advanced Customization',
				'Checkout Extensibility',
				'API Integration',
				'Internationalization',
				'B2B Functionality',
				'Custom Flows Implementation',
			],
			url: '/services/shopify-plus',
		},
		{
			icon: 'integrationIcon',
			heading: 'Apps and Integrations',
			intro: 'We specialize in creating apps and integrations for Shopify stores, tailored to your business needs. Our team of experienced developers ensures that your online store is not only visually appealing but also optimized for performance and user experience.',
			sublist: [
				'App Development',
				'App Integration',
				'API Integration',
				'3D Models Integration',
				'CMS Integration',
				'ERP Integration',
				'CRM Integration',
				'Payment Gateways Integration',
			],
			url: '/services/shopify-apps',
		},
	],
	ro: [
		{
			icon: 'faShopify',
			heading: 'Dezvoltare de teme',
			intro: 'Creăm teme Shopify personalizate care se integrează perfect cu strategia ta de business. Lucrăm împreună cu designerii și echipa ta de marketing pentru a construi experiențe de cumpărare care convertesc. Fiecare temă este gândită să funcționeze armonios cu restul ecosistemului tău digital.',
			sublist: [
				'Teme personalizate pentru brandul tău',
				'Design adaptat pentru toate dispozitivele',
				'Optimizare pentru căutări organice (SEO)',
				'Integrare cu aplicațiile existente',
				'Cod curat și ușor de întreținut',
				'Suport pentru modificări viitoare',
				'Coordonare cu echipa ta de design',
			],
			url: '/ro/servicii-shopify/dezvoltare-teme',
		},
		{
			icon: 'plusIcon',
			heading: 'Shopify Plus',
			intro: 'Pentru afaceri care cresc rapid și au nevoie de mai mult decât un magazin standard. Coordonăm implementarea soluțiilor enterprise cu echipa ta internă și cu alți furnizori de servicii, asigurându-ne că totul funcționează împreună ca un sistem integrat.',
			sublist: [
				'Implementare Shopify Plus',
				'Personalizări pentru procesele tale',
				'Automatizări cu Shopify Flow',
				'Integrări cu sistemele existente',
				'Soluții B2B și B2C',
				'Expansiune pe piețe internaționale',
				'Coordonare cu furnizorii de servicii',
			],
			url: '/ro/servicii-shopify/shopify-plus',
		},
		{
			icon: 'integrationIcon',
			heading: 'Aplicații și integrări',
			intro: 'Dezvoltăm aplicații și integrări care conectează magazinul tău cu restul sistemelor de business. Folosim tehnologii moderne precum Gadget.dev pentru a crea soluții care se integrează perfect cu echipa ta și cu alți furnizori de servicii.',
			sublist: [
				'Aplicații personalizate pentru nevoile tale',
				'Integrări cu sistemele de business',
				'Conectivitate cu CRM și ERP',
				'Automatizări pentru procesele tale',
				'Payment gateway-uri locale',
				'API-uri pentru integrări viitoare',
				'Dezvoltare cu Gadget.dev',
				'Coordonare cu echipa ta tehnică',
			],
			url: '/ro/servicii-shopify/aplicatii-si-integrari',
		},
	],
};

export default homepageServices;
